<template>
    <BranchLoyaltyConfig v-if="$route.query.branch && !$route.query.company"></BranchLoyaltyConfig>
    <CompanyLoyaltyConfig v-else></CompanyLoyaltyConfig>
</template>

<script>
    import BranchLoyaltyConfig from "./BranchLoyaltyConfig.vue";
    import CompanyLoyaltyConfig from "./CompanyLoyaltyConfig.vue";

    export default {
      name: "LoyaltyConfig",

      components: {
        BranchLoyaltyConfig,
        CompanyLoyaltyConfig
      }
    }
</script>